<template>
  <!-- select 2 demo -->
  <div>
    <b-modal
      ref="origin-breakdown-info-modal"
      hide-footer
      hide-header
      scrollable
      @hidden="hiddenModal"
      size="md"
    >
     <div class="model-close-container">
      <button class="close-modal-btn" @click="hiddenModal()"><CloseModalIcon /></button>
     </div>
     <div class="info-modal-container cs-scroll-style" :style="{ 'max-height': $store.state.appConfig.bodyHeight + 'px' }">
        <div class="info-modal-body" :class="{'active' : selectedInfoNumber === 1}">
          <div class="info-modal-header">
            <h5>{{ $tI('Wizard popup Hunter Gatherer and Farmer Main Title') }}</h5>
          </div>
          <p class="description">
            {{ $tI_G('Wizard popup Hunter Gatherer and Farmer Body  ') }}
          </p>
        </div>

        <div class="info-modal-body" :class="{'active' : selectedInfoNumber === 2}">
          <div class="info-modal-header">
            <h5>{{ $tI('Wizard popup Hunter Gatherer and Farmer Main Title') }}</h5>
          </div>
          <div class="third-info-content">
            <div class="third-info-content__reminder-box">
              <h5>{{ $tI('Hunter Gatherers Secondary Title') }}</h5> 
              <p class="description">
                {{ $tI('Wizard popup Hunter Gatherers Body') }}
              </p>
            </div>
          </div>
        </div>

        <div class="info-modal-body" :class="{'active' : selectedInfoNumber === 3}">
          <div class="info-modal-header">
            <h5>{{ $tI('Wizard popup Hunter Gatherer and Farmer Main Title') }}</h5>
          </div>
          <div class="third-info-content">
            <div class="third-info-content__reminder-box">
              <h5>{{ $tI('Farmers Secondary Title') }}</h5> 
              <p class="description">
                {{ $tI('Wizard popup Farmers Body ')}}
              </p>
            </div>
          </div>
        </div>

        <div class="info-modal-body" :class="{'active' : selectedInfoNumber === 4}">
          <div class="info-modal-header">
            <h5>{{ $tI('Wizard popup Migration Secondary Title') }}</h5>
          </div>
          <div class="third-info-content">
            <div class="third-info-content__reminder-box">
              <h5>{{ $tI('Wizard popup Migration Secondary Title') }}</h5> 
              <p class="description">
                {{ $tI('Wizard popup Migration Body') }}
              </p>
            </div>
          </div>
        </div>
        
     </div>
     <div class="model-info-bottom">
      <div>
        <button class="info-modal-btn-prev" @click="prevContainer()" v-if="selectedInfoNumber > 1">{{ $tI('Previous Button') }}</button>
        <div v-else style="width: 60px;"> </div>
      </div>
      <div class="dot-container">
        <div class="dot dot-1" :class="{'active' : selectedInfoNumber === 1}" @click="selectedInfoNumber = 1"></div>
        <div class="dot dot-2" :class="{'active' : selectedInfoNumber === 2}" @click="selectedInfoNumber = 2"></div>
        <div class="dot dot-3" :class="{'active' : selectedInfoNumber === 3}" @click="selectedInfoNumber = 3"></div>
        <div class="dot dot-3" :class="{'active' : selectedInfoNumber === 4}" @click="selectedInfoNumber = 4"></div>
      </div>
      <button class="info-modal-btn" @click="nextContainer()">{{ selectedInfoNumber === 4 ? $tI_G('Got it Button') : $tI('Next Button')}}</button>
     </div>
    </b-modal>
  </div>
</template>

<script>
import communicationService from '@/services/PostMessageCommunation/CommunicationService';
import dataKeys from '@/services/PostMessageCommunation/enums/DataKeys';
import CloseModalIcon from '@/components/icons/CloseModalIcon.vue';
export default {
  components: {
    CloseModalIcon,
  },
  props: {
    modalObject: {
      type: Object,
    },
    callback: {
      type: Function,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      selectedInfoNumber: 1,
    }
  },
  methods: {
    initialModal() {
      communicationService.sendTriggerToParent({ key: dataKeys.MODAL_STATUS, value: true });
      this.$refs['origin-breakdown-info-modal'].show();
    },
    hiddenModal() {
      /* eslint-disable */
      this.modalObject.showModal = false;
      this.$refs['origin-breakdown-info-modal'].hide()
      communicationService.sendTriggerToParent({ key: dataKeys.MODAL_STATUS, value: false });
    },

    nextContainer() {
      if (this.selectedInfoNumber === 4) {
        this.selectedInfoNumber = 1;
        this.hiddenModal();
      } else {
        this.selectedInfoNumber = this.selectedInfoNumber + 1;
      }
    },
    prevContainer() {
      this.selectedInfoNumber = this.selectedInfoNumber - 1;
    },
  },
  computed: {
  },
  mounted() {
    this.initialModal()
  },
};
</script>

<style lang="scss" scoped>
.scale-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 20px auto;
  .scale-bar {
    width: 100%;
    height: 18px;
    border-radius: 10px;
    background: linear-gradient(to right, #36934F, #49CF77, #FF7C55, #EF4232);
    position: relative;
  }

  .labels {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 10px;
  }

  .label {
    font-size: 0.9rem;
    font-weight: 600;
    color: var(--black-40);
  }
}

.info-fit-container {
  width: 100%;
  max-width: 500px;
  background-color: var(--bg-note-color);
  padding: 20px;
  border-radius: 8px;
  margin: 20px auto;
  font-family: Arial, sans-serif;

  &-item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }

  &-color-box {
    width: 40px;
    height: 40px;
    border-radius: 6px;
    margin-right: 15px;
  }

  &-text-content {
    color: #333;

    strong {
      font-size: 0.95rem;
      color: var(--black-70);
    }

    p {
      font-size: 0.93rem;
      line-height: 1.35rem;
      font-weight: 400;
      color: var(--black-70);
      margin: 4px 0 0;
    }
  }

  /* Color variations */
  &-very-close { background-color: #36934F; }
  &-close { background-color: #49CF77; }
  &-moderate { background-color: #FF7C55; }
  &-distant { background-color: #EF4232; }
}

.third-info-content {
    width: 100%;
    max-width: 600px;
    margin: 20px auto;
    font-family: Arial, sans-serif;
    color: #333;

    ul {
      padding-left: 20px;
      list-style-type: disc;

      li {
        margin: 10px 0;
        font-size: 0.95rem;
        color: var(--black-70);
      }
    }

    &__reminder-box {
      background-color: var(--bg-note-color);
      padding: 15px;
      border-radius: 8px;
      margin-top: 20px;

      strong {
        font-weight: bold;
        font-size: 0.95rem;
        color: var(--black-70);
      }
    }
  }
</style>
